(() => {
  const dialog = document.querySelector('[data-boxr-welcome]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const params = new URL(window.location.href).searchParams;
  if (params.has('contact_posted') || params.get('view') === 'international-request') return;
  const dismissedKey = 'boxr-destination-welcome-dismissed';
  try { if (window.sessionStorage.getItem(dismissedKey) === '1') return; } catch (_) { /* Storage can be unavailable; the selector still works. */ }
  const close = dialog.querySelector('[data-welcome-close]');
  const choices = Array.from(dialog.querySelectorAll('[data-welcome-destination]'));
  const status = dialog.querySelector('[data-welcome-status]');
  let busy = false;
  let previousFocus;
  const dismiss = () => {
    if (busy) return;
    try { window.sessionStorage.setItem(dismissedKey, '1'); } catch (_) {}
    dialog.close();
  };
  close.addEventListener('click', dismiss);
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('boxr-welcome-open');
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  });
  choices.forEach((button) => button.addEventListener('click', async () => {
    if (busy) return;
    const flow = document.querySelector('boxr-shipping-destination');
    if (typeof flow?.updateDestination !== 'function' || flow.busy) {
      status.textContent = 'Please wait a moment and try again.';
      return;
    }
    busy = true;
    close.disabled = true;
    choices.forEach((choice) => { choice.disabled = true; });
    dialog.setAttribute('aria-busy', 'true');
    status.textContent = 'Updating your shipping destination…';
    const updated = await flow.updateDestination(button.dataset.welcomeDestination);
    if (updated) {
      // The cart attribute remembers the choice. No separate country preference is stored.
      dialog.close();
      return;
    }
    busy = false;
    close.disabled = false;
    choices.forEach((choice) => { choice.disabled = false; });
    dialog.removeAttribute('aria-busy');
    status.textContent = flow.status.textContent || 'We could not save your destination. Please try again.';
    button.focus();
  }));
  previousFocus = document.activeElement;
  dialog.showModal();
  document.documentElement.classList.add('boxr-welcome-open');
})();
